import React from 'react';
import { Container } from 'reactstrap';
import InnerBanner from '../../components/InnerBanner';
import BannerMask from '../../components/BannerMask';
import ResourceUptoDate from '../../components/ResourceUptoDate';
import GetInTouch from './component/GetInTouch';
import SourceMask from '../../components/SourceMask';
import SEO from '../../components/SEO';

const ContactUs = () => {
  return (
    <>
      <SEO title="Contact Us" />
      <div className="resource contact-us-page">
        <InnerBanner
          title="Contact Us"
          description="Smart legal support, powered by digital expertise. Connect with Legalligence for trusted guidance."
        />
        <section className="section-gap-lg">
          <GetInTouch />
        </section>
        <section className="section-gap-lg pt-0">
          <Container>
            <ResourceUptoDate />
          </Container>
        </section>
      </div>
    </>
  );
};

export default ContactUs;
